export const minWidth = (width, content) => ({
  [`@media screen and (min-width: ${width}px)`]: content,
});
export const maxWidth = (width, content) => ({
  [`@media screen and (max-width: ${width}px)`]: content,
});
export const maxWidthOrientation = (width, orientation, content) => ({
  [`@media screen and (max-width: ${width}px) and (orientation: ${orientation})`]: content,
});

// `xs` is 0 up to `sm`;
export const breakpoints = {
  sm: 768,
  md: 960,
  lg: 1280,
  xl: 1920,
};

export const smallScreen = content => maxWidth(breakpoints.sm - 1, content);
export const largeScreen = content => maxWidth(breakpoints.lg - 1, content);

export const smallScreenL = content => maxWidthOrientation(breakpoints.md, 'landscape', content);
export const responsiveSm = content => minWidth(breakpoints.sm, content);
export const responsiveMd = content => minWidth(breakpoints.md, content);
export const responsiveLg = content => minWidth(breakpoints.lg, content);
export const responsiveXl = content => minWidth(breakpoints.xl, content);
